var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampainsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.340393 10.0424C0.721545 9.2495 1.4049 8.60094 2.29794 8.28854L3.64767 7.81571L13.2978 0.671414C13.4753 0.470226 13.6858 0.323359 13.9303 0.237628C14.8063 -0.0688328 15.8352 0.512664 16.7937 1.70197C18.5874 3.93121 20.0102 7.99482 19.9999 10.8573C19.9932 12.3836 19.5509 13.4803 18.6757 13.7876C18.4312 13.8734 18.1748 13.8895 17.9117 13.8428L6.64508 14.2698L7.77922 17.5058C7.93966 17.9617 7.89721 18.4413 7.70366 18.8471C7.50927 19.2486 7.15187 19.5933 6.69942 19.7469C5.76817 20.0627 4.77582 19.5755 4.45845 18.6663L3.16048 14.9608C1.80733 14.8538 0.623957 13.8937 0.1928 12.6612C-0.119593 11.7698 -0.0397945 10.8335 0.341355 10.0414L0.340393 10.0424ZM15.8514 2.45908C14.4125 0.671305 13.8217 1.19254 13.8149 3.17301C13.8132 3.67302 13.8607 4.23752 13.9617 4.84618C14.5339 4.81817 15.0925 4.96163 15.573 5.23922C17.4227 6.30714 17.5475 8.92513 15.8242 10.1671C16.1264 10.7045 16.4405 11.1764 16.7555 11.5669C17.9974 13.1102 18.7835 13.1476 18.792 10.853C18.8021 8.26801 17.4728 4.47518 15.8506 2.46L15.8514 2.45908Z",
    fill: "#2A3953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampainsIcon);
export default __webpack_public_path__ + "static/media/CampainsIcon.1445fd4c5e84b8a3c03d9704cc613d65.svg";
export { ForwardRef as ReactComponent };